import {Injectable} from '@angular/core';
import {Observable, take} from 'rxjs';
import {BaseApiEndpointService} from '../base-endpoint/base-endpoint.service';
import {ListItem} from '../../types/list-item.type';
import {ServiceProviderHub, SingleResponse} from '@generated-backend-types';
import EventInquiryVariant = ServiceProviderHub.App.Http.Resources.ServiceProviderHub.Eventmanagement.Event.Inquiry.EventInquiryVariant;
import EventInquiryVariantData = ServiceProviderHub.App.Data.ServiceProviderHub.ServiceProviderInquiries.ServiceProviderInquiryVariantData;

@Injectable()
export class EventInquiryVariantsService extends BaseApiEndpointService<EventInquiryVariant, EventInquiryVariantData> {

  public forInquiry(eventId: string, inquiryId: string): void {
    this.endpoint = `/events/${eventId}/inquiries/${inquiryId}/variants`;
  }

  public override update(id: string, data: EventInquiryVariantData): Observable<SingleResponse<EventInquiryVariant>> {
    return this.http
      .patch<SingleResponse<EventInquiryVariant>>(`${this.endpoint}/${id}`, data)
      .pipe(take(1));
  }

  public modelToMultiSelectItem(m: EventInquiryVariant): ListItem & {model: EventInquiryVariant} {
    return {id: m.id, text: String(m.position), isDisabled: false, model: m};
  }
}
